import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const G2Icon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
      >
        <path
          d="M20 10.5C20 15.7478 15.7478 20 10.5 20C5.2522 20 1 15.7478 1 10.5C1 5.2522 5.2522 1 10.5 1C15.7478 1 20 5.256 20 10.5Z"
          fill="#FF492C"
        />
        <path
          d="M14.611 8.94935H12.1562V8.83535C12.1562 8.41735 12.2398 8.07155 12.407 7.80175C12.5742 7.52815 12.863 7.28875 13.281 7.07595L13.471 6.98095C13.8092 6.80995 13.8966 6.66175 13.8966 6.48695C13.8966 6.27795 13.7142 6.12595 13.4216 6.12595C13.072 6.12595 12.8098 6.30835 12.6274 6.67695L12.1562 6.20575C12.2588 5.98535 12.426 5.81055 12.6464 5.66995C12.8706 5.52935 13.1176 5.46095 13.3874 5.46095C13.7256 5.46095 14.0182 5.54835 14.2576 5.73075C14.5046 5.91315 14.6262 6.16395 14.6262 6.47935C14.6262 6.98475 14.3412 7.29255 13.8092 7.56615L13.509 7.71815C13.1898 7.87775 13.034 8.02215 12.9884 8.27675H14.611V8.94935ZM14.3944 9.72455H11.7078L10.3664 12.0501H13.053L14.3982 14.3757L15.7396 12.0501L14.3944 9.72455ZM10.5982 13.6043C8.88817 13.6043 7.49737 12.2135 7.49737 10.5035C7.49737 8.79355 8.88817 7.40275 10.5982 7.40275L11.6622 5.17975C11.3164 5.11135 10.963 5.07715 10.5982 5.07715C7.59997 5.07715 5.16797 7.50915 5.16797 10.5035C5.16797 13.5017 7.59617 15.9337 10.5982 15.9337C11.7914 15.9337 12.8972 15.5461 13.794 14.8925L12.616 12.8557C12.0764 13.3193 11.3696 13.6043 10.5982 13.6043Z"
          fill="white"
        />
      </SvgIcon>
    );
  })
);
